import React from 'react';
import { Header } from './Header';
import { Footer } from './Footer';
import { UsersIcon, TrendingUpIcon, AwardIcon, HeartIcon } from 'lucide-react';
export const AboutPage = () => {
  const values = [{
    icon: <UsersIcon size={24} data-id="element-16" />,
    title: 'Customer First',
    description: "We prioritize our clients' success and build solutions that truly address their needs."
  }, {
    icon: <TrendingUpIcon size={24} data-id="element-17" />,
    title: 'Innovation',
    description: 'Constantly pushing boundaries to deliver cutting-edge AI solutions for enterprises.'
  }, {
    icon: <AwardIcon size={24} data-id="element-18" />,
    title: 'Excellence',
    description: 'Committed to delivering the highest quality in every aspect of our work.'
  }, {
    icon: <HeartIcon size={24} data-id="element-19" />,
    title: 'Integrity',
    description: 'Building trust through transparency, honesty, and ethical business practices.'
  }];
  return <div className="min-h-screen bg-white w-full" data-id="element-20">
      <Header data-id="element-21" />
      <main data-id="element-22">
        {/* Hero Section */}
        <section className="w-full bg-gradient-to-br from-indigo-50 to-blue-50 py-16 sm:py-24" data-id="element-23">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-24">
            <div className="text-center" data-id="element-25">
              <h1 className="text-4xl sm:text-5xl font-bold text-gray-900 leading-tight" data-id="element-26">
                About <span className="text-indigo-600" data-id="element-27">nterpriseAI</span>
              </h1>
              <p className="mt-6 text-xl text-gray-600 max-w-3xl mx-auto" data-id="element-28">
                Transforming enterprises through intelligent AI integration
                across all business verticals.
              </p>
            </div>
          </div>
        </section>
        {/* Founders Note Section */}
        <section className="w-full py-16 bg-white" data-id="element-29">
          <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-30">
            <div className="bg-indigo-50 border-l-4 border-indigo-600 p-8 rounded-r-lg" data-id="element-31">
              <h2 className="text-2xl font-bold text-gray-900 mb-4" data-id="element-32">
                Our Foundation
              </h2>
              <p className="text-lg text-gray-700 leading-relaxed" data-id="element-33">
                nterpriseAI is built by founders involved in developing
                enterprise solutions across sectors for more than 15 years. Our
                deep understanding of enterprise challenges, combined with
                cutting-edge AI technology, enables us to deliver solutions that
                truly transform how businesses operate.
              </p>
            </div>
          </div>
        </section>
        {/* Mission Section */}
        <section className="w-full py-16 bg-gray-50" data-id="element-34">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-35">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-36">
              <div data-id="element-37">
                <h2 className="text-3xl font-bold text-gray-900 mb-6" data-id="element-38">
                  Our Mission
                </h2>
                <p className="text-lg text-gray-600 mb-4" data-id="element-39">
                  We believe that every enterprise, regardless of size or
                  industry, deserves access to powerful AI tools that can
                  streamline operations, enhance decision-making, and drive
                  growth.
                </p>
                <p className="text-lg text-gray-600" data-id="element-40">
                  Our mission is to democratize enterprise AI by providing
                  comprehensive, easy-to-integrate solutions that work
                  seamlessly across HR, Finance, Accounting, Operations, and
                  Vendor Management.
                </p>
              </div>
              <div data-id="element-41">
                <img src="https://images.unsplash.com/photo-1522071820081-009f0129c71c?ixlib=rb-4.0.3&auto=format&fit=crop&w=2070&q=80" alt="Team collaboration" className="rounded-lg shadow-xl" data-id="element-42" />
              </div>
            </div>
          </div>
        </section>
        {/* Values Section */}
        <section className="w-full py-16 bg-white" data-id="element-43">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-44">
            <div className="text-center mb-12" data-id="element-45">
              <h2 className="text-3xl font-bold text-gray-900" data-id="element-46">Our Values</h2>
              <p className="mt-4 text-xl text-gray-600 max-w-3xl mx-auto" data-id="element-47">
                The principles that guide everything we do
              </p>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-48">
              {values.map((value, index) => <div key={index} className="text-center" data-id="element-49">
                  <div className="w-16 h-16 bg-indigo-100 rounded-full flex items-center justify-center text-indigo-600 mx-auto mb-4" data-id="element-50">
                    {value.icon}
                  </div>
                  <h3 className="text-xl font-semibold text-gray-900 mb-2" data-id="element-51">
                    {value.title}
                  </h3>
                  <p className="text-gray-600" data-id="element-52">{value.description}</p>
                </div>)}
            </div>
          </div>
        </section>
        {/* CTA Section */}
        <section className="w-full py-16 bg-indigo-600" data-id="element-53">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-54">
            <h2 className="text-3xl font-bold text-white" data-id="element-55">
              Ready to Work with Us?
            </h2>
            <p className="mt-4 text-xl text-indigo-100 max-w-3xl mx-auto" data-id="element-56">
              Let's discuss how we can help transform your enterprise with AI.
            </p>
            <div className="mt-8 flex justify-center" data-id="element-57">
              <a href="mailto:contact@nterprizeai.com" className="bg-white text-indigo-600 px-6 py-3 rounded-md font-medium hover:bg-gray-100 transition-colors inline-block" data-id="element-58">
                Get in Touch
              </a>
            </div>
          </div>
        </section>
      </main>
      <Footer data-id="element-59" />
    </div>;
};